import { render } from "./TrafficUsers.vue?vue&type=template&id=f680d570"
import script from "./TrafficUsers.vue?vue&type=script&lang=js"
export * from "./TrafficUsers.vue?vue&type=script&lang=js"
script.render = render

export default script